import {HttpClient} from "../../service/httpClient/HttpClient";

export class MemorialNoteService {

    constructor() {
        this.httpClient = new HttpClient()
    }

    getMemorialNoteList(page, size, name, status) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `memorial-notes`,
                {
                    page,
                    size,
                    "name": name && name.length > 0 ? name : null,
                    "status": status && status !== "ALL" && status.length > 0 ? status : null,
                }
            ).then(resolve).catch(reject)
        })
    }

    getMemorialNoteInformation(memorialNoteId) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `memorial-notes/${memorialNoteId}/information`
            ).then(resolve).catch(reject)
        })
    }
    getMemorialNoteStatus(memorialNoteId){
        return new Promise((resolve, reject)=>{
            this.httpClient.get(
                `memorial-notes/${memorialNoteId}/status`
            ).then(resolve).catch(reject)
        })
    }

    updateMemorialNoteStatus(memorialNoteId,status){
        return new Promise((resolve, reject)=>{
            this.httpClient.patch(
                `memorial-notes/${memorialNoteId}/status`,
                {},
                {
                    "status":status
                }
            ).then(resolve).catch(reject)
        })
    }
}